import { Organizer } from 'modules/organizer/domain/interfaces/organizer';
import React, { useMemo } from 'react';
import UDMenuCategories from './components/categoryes';
import MenuTechnical from './components/menu-technical';
import ProfileMenu from './components/profile-menu';
import UDMenuSystemNavigation from './components/system-navigation';
import UDMenuTournaments from './components/tournaments';
import * as S from './styles';

type UDMenuProps = {
  isOrganizerLoading: boolean;
  organizerInfo: Organizer | null;
};

/**
 * Custom comparison function for React.memo
 * Only re-render if the relevant props have changed
 */
const arePropsEqual = (prevProps: UDMenuProps, nextProps: UDMenuProps): boolean => {
  return prevProps.isOrganizerLoading === nextProps.isOrganizerLoading && prevProps.organizerInfo === nextProps.organizerInfo;
};

const UDMenu = React.memo((props: UDMenuProps) => {
  // Memoize the organizer info props to prevent unnecessary re-renders of child components
  const organizerName = useMemo(() => props.organizerInfo?.name, [props.organizerInfo?.name]);
  const organizerLogo = useMemo(() => props.organizerInfo?.logoUrl, [props.organizerInfo?.logoUrl]);
  const isLoading = useMemo(() => props.isOrganizerLoading, [props.isOrganizerLoading]);

  return (
    <S.MenuContainer className="flex flex-col gap-5">
      <S.MenuLogo className="flex items-center px-10" fontSize={20} />
      <div className="flex grow flex-col gap-7">
        <div className="flex flex-col">
          <UDMenuTournaments isOrganizerLoading={isLoading} organizerInfo={props.organizerInfo} />
        </div>

        <div>
          <UDMenuCategories />
        </div>

        <div className="flex flex-col">
          <UDMenuSystemNavigation />
        </div>

        <div className="flex flex-col">
          <MenuTechnical />
        </div>
      </div>

      <ProfileMenu name={organizerName} logo={organizerLogo} loading={isLoading} />
    </S.MenuContainer>
  );
}, arePropsEqual);

export default UDMenu;
